export const NAME = 'settings';
